import { Mesh, Nullable } from '@babylonjs/core';
import { BaseSystem, Zed } from '@modules/core';
import { World } from 'miniplex';

import { Entity as BaseEntity } from '../Entity';

export type LODLevelDefinition = {
  distanceOrScreenCoverage: number;
  mesh?: Nullable<Mesh>;
  /**
   * @deprecated NOT IMPLEMENTED YET
   */
  action?: Mesh['onLODLevelSelection'];
};

export type Entity = BaseEntity & {
  LODDefinition?: {
    useLODScreenCoverage?: true;
    LODs: LODLevelDefinition[];
  };
};

export class LODSystem implements BaseSystem {
  static readonly INJECTABLE_TOKEN = Symbol.for('LODSystem');

  private readonly world;
  private readonly withLOD;

  constructor({ [Zed.WORLD_TOKEN]: world }: { [Zed.WORLD_TOKEN]: World<Entity> }) {
    this.world = world;

    this.withLOD = world.with('LODDefinition', 'TransformNode');

    this.withLOD.onEntityAdded.subscribe(this.whenLOD);
    this.withLOD.onEntityRemoved.subscribe(this.whenLODRemoved);
  }

  private whenLOD = (entity: (typeof this.withLOD.entities)[number]) => {
    const { TransformNode: mesh, LODDefinition } = entity;
    if (!(mesh instanceof Mesh)) {
      console.warn('LODSystem: TransformNode is not a Mesh', mesh);
      return;
    }

    mesh.useLODScreenCoverage = LODDefinition.useLODScreenCoverage ?? false;

    for (const lod of LODDefinition.LODs) {
      mesh.addLODLevel(lod.distanceOrScreenCoverage, lod.mesh ?? null);
    }

    const hasLODAction = LODDefinition.LODs.some((lod) => lod.action);
    if (!hasLODAction) {
      return;
    }

    mesh.onLODLevelSelection = (distance, selected) => {
      if (mesh.id === selected?.id) return;
      console.warn('LODSystem: onLODLevelSelection not implemented yet', distance, selected, selected?.id, mesh.id);
    };
  };

  private whenLODRemoved = ({ TransformNode: mesh, LODDefinition }: (typeof this.withLOD.entities)[number]) => {
    if (!(mesh instanceof Mesh) || mesh.isDisposed()) {
      return;
    }

    const lodMeshes = new Set(LODDefinition.LODs.map((lod) => lod.mesh ?? null));

    lodMeshes.forEach(mesh.removeLODLevel);
  };

  readonly operations = [];
}
